/* ==========================================================================
   Clínica Vie Et Santé — correcciones puntuales de accesibilidad.
   Se hacen desde el tema (no editando archivos core grandes) para no arriesgar
   regresiones. Lighthouse/axe y los agentes que ejecutan JS evalúan el árbol
   ya corregido.
   ========================================================================== */
(function () {
  function run() {
    // 1) Rol ARIA inválido en el botón "Más" del menú NATIVO de Horizon
    //    (blocks/_header-menu.liquid): <button role="listitem"> huérfano rompe
    //    el árbol de accesibilidad. El <li> contenedor ya aporta la semántica.
    document.querySelectorAll('button.menu-list__link[role="listitem"]').forEach(function (b) {
      b.removeAttribute('role');
    });

    // 2) Ticker del equipo: el marquee duplica la lista de tips para el loop
    //    visual; la copia va con aria-hidden="true" pero sus enlaces siguen
    //    siendo enfocables con teclado. La marcamos inert: fuera del foco y
    //    del árbol de AT. Los mismos enlaces siguen accesibles en la copia real.
    document.querySelectorAll('.ves-team__tips[aria-hidden="true"]').forEach(function (ul) {
      ul.inert = true;
    });
  }

  if (document.readyState !== 'loading') {
    run();
  } else {
    document.addEventListener('DOMContentLoaded', run);
  }
  document.addEventListener('shopify:section:load', run);
})();
